import BaseMixin from './base-mixin';
import getErrorMessage from '../utils/error-message';

export default {
    mixins: [BaseMixin],
    data() {
        return {
            alertType: 'successed',
            alertVisible: false,
            alertMessage: null
        };
    },
    created() {
        this.initAlert();
    },
    methods: {
        initAlert() {
            if (this.$root.hasInitEventHub) {
                return;
            }
            this.$root.hasInitEventHub = true;
            if (!this.$eventHub) {
                console.warn('this.$eventHub is undefined');
                return;
            }
            this.$eventHub.$on('ALERT', options => {
                this.alertVisible = true;
                this.alertType = options.type;
                this.alertMessage = options.message;
            });
        },
        alertOnClose() {
            this.alertVisible = false;
            this.alertMessage = null;
            this.alertType = 'successed';
        },
        alertMixin_isError(o) { return (o || {}) instanceof Error; },
        alertMixin_getErrorMessage(error) {
            return getErrorMessage(error, this)
        },
        errorHandler(error) {
            this.messageHandler('error', this.alertMixin_getErrorMessage(error));
        },
        messageHandler(type, message) {
            if (this.$eventHub) {
                this.$eventHub.$emit('ALERT', { type, message });
            } else {
                console.warn('this.$eventHub is undefined');
            }
        },
        warnAlert(message) {
            this.messageHandler('warning', message);
        },
        errorAlert(message) {
            this.messageHandler('error', message);
        },
        successAlert(message) {
            this.messageHandler('successed', message);
        },
        processingAlert(message) {
            this.messageHandler('processing', message);
        },
        otherAlert(message) {
            this.messageHandler('processing', message);
        }
    }
};
